module.exports = __webpack_public_path__ + "static/media/CentroMedicoSantaIsabel.6cc2d472.svg";